import { auth } from "../firebase/firebaseConfig";
import { CartResponseDTO } from "../dto/CartDTO";

const endpoint = process.env.REACT_APP_API_ENDPOINT;

// Helper function to get a valid authentication token
const getValidToken = async (): Promise<string> => {
    try {
        const token = await auth.currentUser?.getIdToken(true); // Force refresh
        if (!token) {
            throw new Error("Error 401: Unauthorized - No authentication token available");
        }
        return token;
    } catch (error) {
        throw new Error("Error 401: Unauthorized - Authentication token refresh failed");
    }
};

export class CartService {
    public static async GetCart(): Promise<CartResponseDTO> {
        try {
            const token = await getValidToken();
           
            const response = await fetch(`${endpoint}/cart/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static async AddItem(bookId: string, quantity: number): Promise<CartResponseDTO> {
        try {
            const token = await getValidToken();
            
            const response = await fetch(`${endpoint}/cart/add`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                body: JSON.stringify({
                    bookId,
                    quantity
                })  
            });

            if (response.status === 400) {
                const errorData = await response.json();
                return errorData;
            }

            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            
            const data = await response.json();
            return data.cart;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static async UpdateItem(bookId: string, quantity: number): Promise<CartResponseDTO> {
        try {
            const token = await getValidToken();
            const response = await fetch(`${endpoint}/cart/update`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                body: JSON.stringify({
                    bookId,
                    quantity
                })  
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            const data = await response.json();
            return data.cart;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static async RemoveItem(bookId: string): Promise<CartResponseDTO> {
        try {
            const token = await getValidToken();
            const response = await fetch(`${endpoint}/cart/item/${bookId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': token
                },
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static async CreateOrder() {
        try {
            const token = await getValidToken();
            
            const response = await fetch(`${endpoint}/order/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            
            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static async AddNewCard(token: string) {
        try {
            const AuthToken = await getValidToken();
            const response = await fetch(`${endpoint}/stripe/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': AuthToken
                },
                body: JSON.stringify({
                    token: token
                })
            });
            // if (!response.ok) {
            //     throw new Error(`Error ${response.status}: ${response.statusText}`);
            // }
            
            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }

    public static async RemoveCard(paymentMethodId: string) {
        try {
            const AuthToken = await getValidToken();
            const response = await fetch(`${endpoint}/stripe/delete`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': AuthToken
                },
                body: JSON.stringify({
                  paymentMethodId: paymentMethodId
                })
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
            
            const data = await response.json();
            return data;
        } catch (er: any) {
            throw new Error(er.message);
        }
    }
}